// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Root/style.css
 ** module id = 1590
 ** module chunks = 0
 **/